import React from "react";
import { DetailNextProps } from "models/DetailNext";

import mockup from "mockup";
import { useNavigation } from "hooks/useNavigation";

import "./index.scss";
import { ReactSVG } from "react-svg";

import ArrowRight from "assets/icon/arrow-right.svg";

const DetailNext = ({ id }: DetailNextProps) => {
  const navigate = useNavigation();

  const cocktail = mockup.find(({ id: dataId }) => dataId === id);

  return (
    <div className="detail-next">
      {cocktail && (
        <>
          <div className="detail-next-content">
            <span className="body">Discover also</span>
            <h2 className="heading-4">{cocktail.title}</h2>
          </div>

          <ReactSVG
            src={ArrowRight}
            className="cta circle-icon"
            onClick={() => navigate(`/detail/${id}`)}
          />
        </>
      )}
    </div>
  );
};

export default DetailNext;
